<template>
  <section class="short-deck-equity-calculator">
    <div class="simulation-progress"></div>
    <saved-scenario-alert
      v-if="savedScenario"
      v-bind:title="savedScenario.title"
    />
    <!-- <section v-if="!authorizedForShortDeck" class="alert alert-info">
      Interested in the short deck <router-link to="/help/hit-calculator">hit calculator</router-link> too? Head over to the <router-link v-if="loggedIn" to="/purchase-short-deck">purchase page</router-link><router-link v-else to="/short-deck-pricing">pricing page</router-link>.
    </section> -->
    <equity-calculator-controls
      v-bind:presetCommunityCards="state.presetCommunityCards"
      v-bind:hasSimulationBeenRun="state.hasSimulationBeenRun"
      v-bind:savedScenario="savedScenario"
      v-bind:shortDeck="true"
      v-bind:disabled="!authorized"
      v-bind:loggedIn="loggedIn"
      v-on:setIndividualPresetCommunityCard="setIndividualPresetCommunityCard($event)"
      v-on:setBoard="setBoard($event)"
      v-on:removePresetCommunityCard="removePresetCommunityCard($event)"
      v-on:addPlayer="addPlayer()"
      v-on:createSharableUrl="createSharableUrl()"
      v-on:saveScenario="expandSaveScenarioModal()"
      v-on:updateScenario="updateScenario()"
      v-on:simulate="simulate()"
    />
    <div class="row">
      <div
        v-for="(player, playerIndex) in state.players._players"
        v-bind:key="player.id"
        v-bind:class="columnClass"
      >
        <!-- <equity-calculator-insights
          v-if="insightsVisible && playerIndex === 0"
          v-bind:hasSimulationBeenRun="state.hasSimulationBeenRun"
          v-bind:equity="player.states[0].equity"
        /> -->
        <short-deck-hand-range
          v-bind:ref="'player' + playerIndex"
          v-bind:class="{
            'insights-visible': insightsVisible,
            'second-player': playerIndex === 1,
            'third-player': playerIndex === 2,
            'two-or-four-players': state.players.numPlayers === 2 || state.players.numPlayers === 4,
            'three-five-or-more-players': state.players.numPlayers === 3 || state.players.numPlayers >= 5,
          }"
          v-bind:generalHands="player.states[0].generalHands"
          v-bind:weightToApplyToAddedHands="player.weightToApplyToAddedHands"
          v-bind:combosToAdd="player.combosToAdd"
          v-bind:disableAllButGridSelector="false"
          v-bind:disableAllSelectors="!authorized"
          v-bind:canBeRemoved="playerIndex > 1"
          v-on:removePlayer="player.handleRemovePlayerEvent('shortDeckEquityCalculator', $store, playerIndex)"
          v-on:clearRange="player.handleClearPlayerEvent('shortDeckEquityCalculator', $store, playerIndex, 0)"
          v-on:addComboToCombosToAdd="player.handleAddComboToCombosToAddEvent('shortDeckEquityCalculator', $store, $event, playerIndex)"
          v-on:removeComboFromCombosToAdd="player.handleRemoveComboFromCombosToAddEvent('shortDeckEquityCalculator', $store, $event, playerIndex)"
          v-on:applyExactWeightToGeneralHands="player.handleApplyExactWeightToGeneralHandsEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:selectGeneralHand="player.handleSelectGeneralHandEvent('shortDeckEquityCalculator', $store, $event.generalHandString, $event.triggeredByMouseover, playerIndex, 0)"
          v-on:deselectGeneralHand="player.handleDeselectGeneralHandEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:selectGeneralHands="player.handleSelectGeneralHandsEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:deselectGeneralHands="player.handleDeselectGeneralHandsEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:selectSpecificHand="player.handleSelectSpecificHandEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:deselectSpecificHand="player.handleDeselectSpecificHandEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:setRangeToMatchGeneralHands="player.handleSetRangeToMatchGeneralHandsEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:setRangeToMatchDoubleSlider="player.handleSetRangeToMatchDoubleSliderEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0, handRankings)"
          v-on:setRangeToMatchSpecificHandStrings="player.handleSetRangeToMatchSpecificHandStringsEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:applyExactWeightToGeneralHand="player.handleApplyExactWeightToGeneralHandEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:setWeightOfSpecificHand="player.handleSetWeightOfSpecificHandEvent('shortDeckEquityCalculator', $store, $event, playerIndex, 0)"
          v-on:setWeightToApplyToAddedHands="player.handleSetWeightToApplyToAddedHandsEvent('shortDeckEquityCalculator', $store, $event, playerIndex)"
        >
          <equity-results
            slot="left-header"
            v-bind:equity="player.states[0].equity"
            v-bind:equityString="player.states[0].equityString"
            v-bind:winPercentageString="player.states[0].winPercentageString"
            v-bind:tiePercentageString="player.states[0].tiePercentageString"
            v-bind:hasSimulationBeenRun="state.hasSimulationBeenRun"
          />
          <li
            v-if="state.presetCommunityCards.flopSet"
            slot="extra-dropdown-item-1"
            v-on:click="expandNarrowRangeModal(playerIndex)"
          >
            <a>Narrow range <span class="glyphicon glyphicon-new-window"></span></a>
          </li>
        </short-deck-hand-range>
      </div>
    </div>
    <narrow-range-modal
      class="narrow-range-modal"
      v-on:narrowRange="narrowRange($event)"
    />
    <sharable-url-modal
      v-bind:url="sharableUrl.url"
      v-bind:approximateWaitTime="sharableUrl.approximateWaitTime"
    />
    <save-scenario-modal
      v-on:save="saveScenario($event)"
    />
    <onboarding-modal
      toolName="equity calculator"
      urlPath="equity-calculator"
    />
  </section>
</template>

<script>
import SavedScenarioAlert from '@/components/utilities/saved-scenario-alert';
import EquityCalculatorInsights from '@/components/equity-calculator/insights';
import ShortDeckHandRange from '@/components/short-deck/short-deck-hand-range';
import EquityResults from '@/components/hand-range/equity-results';
import NarrowRangeModal from '@/components/equity-calculator/narrow-range-modal';
import EquityCalculatorControls from '@/components/equity-calculator/controls';
import SharableUrlModal from '@/components/sharable-url-modal';
import shareUrlService from '@/services/share-url-service';
import SaveScenarioModal from '@/components/save-scenario-modal';
import OnboardingModal from '@/components/onboarding-modal';
import HelpIcon from '@/components/help-icon';
import validator from '@/services/simulator/validator';
import simulator from '@/services/simulator/simulator';
import _ from 'lodash';

export default {
  name: 'short-deck-equity-calculator',
  components: {
    'saved-scenario-alert': SavedScenarioAlert,
    'equity-calculator-insights': EquityCalculatorInsights,
    'short-deck-hand-range': ShortDeckHandRange,
    'equity-results': EquityResults,
    'narrow-range-modal': NarrowRangeModal,
    'equity-calculator-controls': EquityCalculatorControls,
    'sharable-url-modal': SharableUrlModal,
    'save-scenario-modal': SaveScenarioModal,
    'onboarding-modal': OnboardingModal,
    'help-icon': HelpIcon,
  },
  data: function () {
    return {
      playerIndexThatExpandedTheNarrowRangeModal: null,
      sharableUrl: {
        url: null,
        approximateWaitTime: null,
      },
    };
  },
  computed: {
    state: function () {
      return this.$store.state.shortDeckEquityCalculator;
    },
    savedScenario: function () {
      let routeId = this.$route.params.id;

      let user = this.$store.state.account.user;

      if (!user.savedScenarios.shortDeckEquityCalculator || !this.authorized) {
        return false;
      }
      return user.savedScenarios.shortDeckEquityCalculator.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    insightsVisible: function () {
      return this.$store.state.account.user.settings.equityCalculator.insightsVisible;
    },
    columnClass: function () {
      if (this.state.players.numPlayers === 2 || this.state.players.numPlayers === 4) {
        return 'col-md-6';
      }

      return 'col-lg-4';
    },
    handRankings: function () {
      return this.$store.getters['account/handRankings'];
    },
    authorized: function () {
      return true; // short deck equity calculator is free
    },
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
    authorizedForShortDeck: function () {
      return this.$store.getters['account/authorizedForShortDeck'];
    },
  },
  mounted: function () {

    if (this.state.players.numPlayers === 1) {
      this.addPlayer();
    }

    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();
  },
  methods: {
    // mounted
    load: function () {
      let self = this;

      self.$http.get(`${process.env.BASE_API_URL}/sharable-url-store/` + self.$route.params.id)
        .then(function (response) {
          if (!response || !response.data.storeState) {
            alert('Didn\'t get data back from server. Redirecting to the default short deck equity calculator page.');
            self.$router.push('/short-deck/equity-calculator');
          } else {
            self.$store.commit('shortDeckEquityCalculator/setState', response.data.storeState);
            self.$store.commit('shortDeckEquityCalculator/setHasSimulationBeenRun', true);
          }
        })
        .catch(function () {
          alert('URL doesn\'t exist. Redirecting to the default short deck equity calculator page.');
          self.$router.push('/short-deck/equity-calculator');
        })
      ;
    },
    handleOnboard: function () {
      let self = this;

      if (
        !self.loggedIn ||
        !self.authorized ||
        !self.$store.state.account.user.settings.onboarding ||
        self.$store.state.account.user.settings.onboarding.shortDeckEquityCalculator
      ) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http
        .patch(`${process.env.BASE_API_URL}/user/onboard`, { page: 'shortDeckEquityCalculator' })
        .then(function () {
          self.$store.commit('account/onboard', 'shortDeckEquityCalculator');
        })
        .catch(function () {
          console.log('Error: Unable to onboard.');
        })
      ;
    },

    // range
    resetDoubleSlider: function (playerIndex) {
      if (this.$store.state.account.user.settings.general.includedSelectors.slider === 'log double' || this.$store.state.account.useer.settings.general.includedSelectors.slider === 'double') {
        this.$refs['player' + playerIndex][0].resetDoubleSlider();
      }
    },
    resetDoubleSliders: function () {
      this.state.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    },

    // hamburger
    expandNarrowRangeModal: function (playerIndexThatExpandedTheNarrowRangeModal) {
      $(this.$el).find('.narrow-range-modal').modal();
      this.playerIndexThatExpandedTheNarrowRangeModal = playerIndexThatExpandedTheNarrowRangeModal;
    },
    narrowRange: function (checkedHands) {
      this.$store.commit('shortDeckEquityCalculator/narrowRange', {
        checkedHands: checkedHands,
        playerIndex: this.playerIndexThatExpandedTheNarrowRangeModal,
      });
      this.resetDoubleSlider(this.playerIndexThatExpandedTheNarrowRangeModal);
    },

    // controls
    setIndividualPresetCommunityCard: function (params) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', params.position);
      this.$store.commit('shortDeckEquityCalculator/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.resetDoubleSliders();
    },
    setBoard: function (boardCards) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop1');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop2');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop3');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'turn');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'river');
      this.$store.commit('shortDeckEquityCalculator/setBoard', boardCards);
      this.resetDoubleSliders();
    },
    removePresetCommunityCard: function (position) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', position);
    },
    addPlayer: function () {
      this.$store.commit('shortDeckEquityCalculator/addPlayer');
    },
    createSharableUrl: function () {
      let self = this;

      $(self.$el).find('.sharable-url-modal').modal();
      self.sharableUrl.url = '';

      shareUrlService.createSharableEquityCalculatorURL(self.state)
        .then(function (response) {
          if (response.data.url) {
            self.sharableUrl.url = response.data.url.replace('/equity-calculator', '/short-deck/equity-calculator');
          } else {
            alert('Didn\'t get url back from server.');
            throw new Error('Didn\'t get url back from server.');
          }
        })
        .catch(function () {
          alert('Problem trying to create the sharable URL.');
          throw new Error('Problem trying to create the sharable URL.');
        })
      ;
    },
    expandSaveScenarioModal: function () {
      $(this.$el).find('.save-scenario-modal').modal();
    },
    saveScenario: function (title) {
      let self = this;
      let savedScenarioUrl;

      shareUrlService.createSharableEquityCalculatorURL(self.state)
        .then(function getUrlForSavedScenario (response) {
          if (response.data.url) {
            return response.data.url.replace('/equity-calculator', '/short-deck/equity-calculator');
          } else {
            alert('Problem trying to save the scenario.');
            throw new Error('Didn\'t get url back from server.');
          }
        })
        .then(function updateUserOnServer (url) {
          let newSavedScenarios = self._getNewSavedScenarios(title, url);
          let user = _.cloneDeep(self.$store.state.account.user);

          savedScenarioUrl = url;
          user.savedScenarios = newSavedScenarios;

          return self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user });
        })
        .then(function updateUserOnClient (res) {
          self.$store.commit('account/setUser', res.data.user);
          alert('Saved!');
          window.location.href = savedScenarioUrl;
        })
        .catch(function () {
          alert('Problem trying to save the scenario.');
          throw new Error('Problem trying to save the scenario.');
        })
      ;
    },
    _getNewSavedScenarios: function (title, url) {
      let newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios.shortDeckEquityCalculator.push({
        title: title,
        url: url,
      });

      return newSavedScenarios;
    },
    updateScenario: function () {
      let storeState = shareUrlService._constructEquityCalculatorData(this.state);

      this.$http.put(`${process.env.BASE_API_URL}/update-sharable-url/` + this.$route.params.id, storeState)
        .then(function () {
          alert('Successfully updated scenario.');
        })
        .catch(function () {
          alert('Error: unable to update scenario. Email contact@sixplusholdem.com for assistance.');
        })
      ;
    },
    simulate: function () {
      let self = this;
      let validateResult = validator.validateBeforeEquityCalculatorSimulation(self.state.players, self.state.presetCommunityCards);
      let numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;
      let $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      let weightedRanges;

      if (!self.authorized) {
        return;
      }

      if (validateResult.error) {
        alert(validateResult.errorMessage);
        return;
      }

      $simulationButtonText.text('Simulating...');
      weightedRanges = self._getWeightedRanges();
      simulator
        .getShortDeckEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, self._incrementSimulationProgress)
        .then(function (simulationResults) {
          self._resetSimulationProgress();
          self.$store.commit('shortDeckEquityCalculator/updateEquityResults', {
            simulationResults: simulationResults,
            numberOfSimulations: numberOfSimulations,
            rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
            tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
          });
        })
        .catch(function (e) {
          console.error(e);
          self._resetSimulationProgress();
          alert('Encountered an unexpected problem while running the simulations.');
        })
      ;
    },
    _getWeightedRanges: function () {
      let weightedRanges = [];

      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[0].generalHands.weightedRange);
      });

      return weightedRanges;
    },
    _incrementSimulationProgress: function (value) {
      let $simulationProgress = $(this.$el).find('.simulation-progress');
      let $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      let $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    _resetSimulationProgress: function () {
      let $simulationProgress = $(this.$el).find('.simulation-progress');
      let $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      let $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      let $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    },
  },
};
</script>

<style lang="scss" scoped>
  .simulation-progress {
    position: fixed;
    top: 0;
    left: 0;
    height: 5px;
    background: #5cb85c6e;
    z-index: 1;
  }

  .alert {
    font-size: 14px;
  }

  .short-deck-hand-range {
    margin-bottom: 12px;
  }

  // right or bottom
  @media (max-width: 1259px) and (min-width: 992px) {
    .short-deck-hand-range.two-or-four-players /deep/ .panel-body {
      white-space: normal;
    }

    .short-deck-hand-range.two-or-four-players /deep/ .right-or-bottom {
      margin-top: 20px;
    }
  }

  @media (min-width: 1200px) {
    .short-deck-hand-range.three-five-or-more-players /deep/ .panel-body {
      white-space: normal;
    }

    .short-deck-hand-range.three-five-or-more-players /deep/ .right-or-bottom {
      margin-top: 20px;
    }
  }

  // tier selector
  @media (max-width: 1259px) and (min-width: 992px) {
    .short-deck-hand-range.two-or-four-players /deep/ .tier-selector .mobile {
      display: block;
      max-width: 350px;
      width: 100%;
      margin-top: 10px;
      margin-left: 0px;
    }

    .short-deck-hand-range.two-or-four-players /deep/ .tier-selector .non-mobile {
      display: none;
    }
  }

  @media (min-width: 1200px) {
    .short-deck-hand-range.three-five-or-more-players /deep/ .tier-selector .mobile {
      display: block;
      max-width: 350px;
      width: 100%;
      margin-top: 10px;
      margin-left: 0px;
    }

    .short-deck-hand-range.three-five-or-more-players /deep/ .tier-selector .non-mobile {
      display: none;
    }
  }

  // category selector
  @media (max-width: 1259px) and (min-width: 992px) {
    .short-deck-hand-range:not(.three-five-or-more-players) /deep/ .category-selector {
      margin-top: 20px;
      width: 100%;
      margin-left: 0 !important;

      td:nth-child(2) {
        width: 100px;
      }
    }
  }

  @media (min-width: 1200px) {
    .short-deck-hand-range.three-five-or-more-players /deep/ .category-selector {
      margin-top: 20px;
      width: 100%;
      margin-left: 0 !important;

      td:nth-child(2) {
        width: 100px;
      }
    }
  }

  // controls
  .equity-calculator-controls {
    display: grid;
    grid-template-columns: 320px 150px 200px 150px 1fr;
    grid-gap: 10px;
    align-items: start;
  }

  // insights
  // .equity-calculator-insights /deep/ .table {
  //   margin-bottom: 10px;
  // }

  // give margin top to take up space where insights section would be
  // .second-player.insights-visible, .third-player.insights-visible {
  //   margin-top: 78px;
  // }

  // don't need margin top to take up space where equity calculator would be
  // for third player when there are four players because the third player is underneath
  .col-md-6 .third-player {
    margin-top: 0;
  }

  // don't need margin top to take up space where insights section
  // would be when the players are stacked
  @media (max-width: 1199px) {
    .col-lg-4 .second-player, .col-lg-4 .third-player {
      margin-top: 0;
    }
  }

  @media (max-width: 991px) {
    .col-md-6 .second-player, .col-md-6 .third-player {
      margin-top: 0;
    }
  }

  // full width buttons on smaller screens
  @media (max-width: 991px) {
    .equity-calculator-controls {
      display: block;
    }

    .equity-calculator-controls /deep/ .add-player-button-container .add-player-button {
      width: 100% !important;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .equity-calculator-controls /deep/ .create-sharable-url-button-container .create-sharable-url-button, .equity-calculator-controls /deep/ .save-scenario-button-container .save-scenario-button {
      width: 100% !important;
      margin-bottom: 20px;
    }
  }


  // set weight to apply to added hands
  .short-deck-hand-range {
    @media (max-width: 1320px) and (min-width: 1200px) {
      &.short-deck-hand-range.three-five-or-more-players /deep/ .vertical-set-weight-to-apply-to-added-hands-basic {
        display: none;
      }

      &.short-deck-hand-range.three-five-or-more-players /deep/ .horizontal-set-weight-to-apply-to-added-hands-basic {
        display: inline-block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck/short-deck-equity-calculator.vue